import { httpPost, httpPatchMerge, httpDelete } from './http'
import type { TEntityId } from '~/types/models'
import type { IOrderTeamMember } from '~/types/order/models'

const apiEntityPath = '/api/orderteammembers'

export async function createOrderTeamMember(entity: IOrderTeamMember) {
  const callingMn = createOrderTeamMember.name
  const apiPath = apiEntityPath
  return httpPost<IOrderTeamMember>({
    callingMn,
    apiPath,
    entity,
  })
}

export async function updateOrderTeamMember(
  entityData: Partial<IOrderTeamMember>,
  id: TEntityId
) {
  const callingMn = updateOrderTeamMember.name
  const apiPath = `${apiEntityPath}/${id}`
  type TPartialOrderTeamMember = Partial<IOrderTeamMember>
  return httpPatchMerge<TPartialOrderTeamMember>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function deleteOrderTeamMember(entityData: IOrderTeamMember) {
  const callingMn = deleteOrderTeamMember.name
  const apiPath = apiEntityPath
  return httpDelete<IOrderTeamMember>({
    callingMn,
    apiPath,
    entityData,
  })
}
